import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import axios from "axios";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageFour from "./PageFour";
import LoadingPage from "./LoadingPage";
// import jsonFile from "./rpt-pmt-merdekaBelajarBlmSelesai.json";

const PageEight = ({ idJadwalCbt, idKelas, kodeTahunAjaran, schoolName }) => {
    const [fetching, setFetching] = useState(false);
    const [assesmentSiswa, SetAssesmentSiswa] = useState([]);
    const [headerMapel, SetHeaderMapel] = useState([]);
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_EIGHT, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                })
                .catch(function (error) {
                    console.error("Error Response Page Eight", error);
                });

            if (response) {
                if (response.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Eight ", responseAPI);
                    console.log("====================================");

                    SetAssesmentSiswa(responseAPI.listAsessmentSiswa);
                    SetHeaderMapel(responseAPI.listHeaderMataPelajaran);
                }
                setFetching(false);
                // setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <div>
            <div className="report-page">
                <div className="cardLine">
                    {/* header */}
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>08</span>
                        </div>
                        <div className="pnl-date">
                            https://eduprime.co.id/
                        </div>
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <span className="title-header2" style={{ color: '#015E56', fontSize: '25px', }}>Hasil Asesmen Diagnostik </span>
                            <p style={{ color: '#015E56', fontSize: '24px', fontWeight: '500', marginTop: '10px' }}>{schoolName} </p>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', }}>
                            <div className="label-sub-tit">
                                <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '700' }}>SEKOLAH</span>
                            </div>
                        </div>
                    </div>
                    <Gap height={50} />
                    <div className="result">
                        <GridInline width={"100%"}>
                            <LabelTitle label={"Rekapitulasi Siswa Belum Menyelesaikan Keseluruhan Asesmen"} size={18} bolder={700} color={"#212529"} />
                        </GridInline>
                        <Gap height={20} />
                        <div className="rekap-table">
                            <Table size="sm" style={{ fontSize: 14 }}>
                                <thead style={{ backgroundColor: "#BEF264", fontSize: 15, textAlign: "center" }}>
                                    <tr>
                                        <th
                                            width="150"
                                            height="50"
                                            colSpan={2}
                                            style={{
                                                textAlign: "left",
                                                paddingLeft: 15,
                                            }}
                                        >
                                            Nama Siswa
                                        </th>
                                        {headerMapel.map((mapel, i) => {
                                            return (
                                                <th key={i} width={30}>
                                                    {mapel.deskripsi}
                                                </th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                {assesmentSiswa.map((siswa, b) => {
                                    return (
                                        <>
                                            <tr
                                                width="100%"
                                                height="40"
                                                style={{
                                                    backgroundColor: "#F8F9FA",
                                                    textAlign: "center",
                                                }}
                                            >
                                                <td>{b + 1}</td>
                                                <td
                                                    style={{
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    {siswa.namaSiswa}
                                                </td>
                                                {siswa.listAsessment.map((score, d) => {
                                                    return (
                                                        <>
                                                            {score.akademik == true && score.status == true ? (
                                                                <td>{score.skor}</td>
                                                            ) : score.akademik == true && score.status == false ? (
                                                                <td>
                                                                    <b style={{ color: "red" }}>X</b>
                                                                </td>
                                                            ) : score.akademik == false && score.status == true ? (
                                                                <td>
                                                                    <img src="/assets/image/pemetaan/bi_check.png" width={"80%"} />
                                                                </td>
                                                            ) : (
                                                                <td>
                                                                    <b style={{ color: "red" }}>X</b>
                                                                </td>
                                                            )}
                                                        </>
                                                    );
                                                })}
                                            </tr>
                                        </>
                                    );
                                })}
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageEight;
